import { findLibraryIcon } from '@/lib/icon-library';
import type { IconContent, ScriptElement } from '@/lib/schema.types';

/**
 * Renders a lucide glyph chosen from the shared icon library by `content.id`.
 * The classroom renders the same glyph for the same id (parity spec §13).
 */
export function IconElement({ element }: { element: ScriptElement }) {
  const c = element.content as IconContent | undefined;
  const { Glyph, name } = findLibraryIcon(c?.id);
  const size = c?.size ?? 64;
  const color = (element.style?.color as string | undefined) ?? '#6366f1';

  return (
    <div className="flex flex-col items-center justify-center gap-1 p-1">
      <Glyph size={size} strokeWidth={c?.strokeWidth ?? 2} color={color} aria-label={name} />
      {c?.caption ? (
        <span className="text-center text-xs text-fg-subtle" style={{ color }}>
          {c.caption}
        </span>
      ) : null}
    </div>
  );
}
